import { Injectable } from '@angular/core';
import { Params, Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { AccountService } from './account.service';
import { UserService } from './user.service';
import { AccountAdminPickerComponent } from '../account-admin-picker/account-admin-picker.component';

@Injectable({ providedIn: 'root' })
export class AccountAdminNavigationService {
  constructor(
    private accountService: AccountService,
    private userService: UserService,
    private router: Router,
    private modalController: ModalController,
  ) {}

  async navigateToAccountAdmin(queryParams: Params = {}): Promise<void> {
    if (this.userService.isLoggedInAsAnotherUser()) {
      const loginAsAccount = this.userService.getLoginData()?.loggedInAs?.account;
      if (loginAsAccount != null) {
        this.accountService.setCurrent(loginAsAccount);
      }
      await this.router.navigate(['/account-admin'], { queryParams });
      return;
    }

    const adminAccounts = await this.userService.getAdminAccounts();
    const currentAccount = parseInt(String(this.accountService.getCurrentAccount()), 10);

    if (adminAccounts.length === 0) {
      await this.router.navigate(['/account-admin'], { queryParams });
      return;
    }

    if (adminAccounts.length === 1) {
      const target = adminAccounts[0];
      if (currentAccount !== target.id) {
        await this.accountService.view(target.id);
      }
      await this.router.navigate(['/account-admin'], { queryParams });
      return;
    }

    const modal = await this.modalController.create({
      component: AccountAdminPickerComponent,
      componentProps: { adminAccounts },
      cssClass: 'account-admin-picker-modal',
    });
    await modal.present();
    const { data } = await modal.onDidDismiss();
    if (data?.accountId) {
      if (currentAccount !== data.accountId) {
        await this.accountService.view(data.accountId);
      }
      await this.router.navigate(['/account-admin'], { queryParams });
    }
  }
}
